import React, { useEffect, useState } from "react";
import {
  FaEnvelope, FaPhone, FaWhatsapp, FaLinkedin, FaGithub, FaInstagram,
  FaMapMarkerAlt, FaCheckCircle, FaPaperPlane, FaArrowRight,
} from "react-icons/fa";

/* c = brand colour used for the icon tile and hover glow */
const DIRECT = [
  { icon: FaEnvelope,  title: "Email",    value: "aayambht@gmail.com", link: "mailto:aayambht@gmail.com",    c: "#ff6b6b" },
  { icon: FaWhatsapp,  title: "WhatsApp", value: "+977 9849610810",    link: "https://wa.me/9779849610810",  c: "#25d366" },
  { icon: FaPhone,     title: "Phone",    value: "+977 9849610810",    link: "tel:+9779849610810",           c: "#46d369" },
];

const ONLINE = [
  { icon: FaLinkedin,  title: "LinkedIn",  value: "aayam-bhattarai", link: "https://np.linkedin.com/in/aayam-bhattarai-1ba53b343", c: "#3b9cf0" },
  { icon: FaGithub,    title: "GitHub",    value: "aayam17",         link: "https://github.com/aayam17",                           c: "#e6e6e6" },
  { icon: FaInstagram, title: "Instagram", value: "aayambhattarai_", link: "https://www.instagram.com/aayambhattarai_/",           c: "#e1306c" },
];

const LOCATION = { icon: FaMapMarkerAlt, title: "Location", value: "Bhaktapur, Nepal", link: null, c: "#f5c542" };

const RULES = {
  name:    v => (v.trim().length >= 2 ? "" : "Please enter your name."),
  email:   v => (/^\S+@\S+\.\S+$/.test(v.trim()) ? "" : "Enter a valid email address."),
  message: v => (v.trim().length >= 10 ? "" : "Your message should be at least 10 characters."),
};

function Field({ name, label, type = "text", area, err, onBlur, auto }) {
  const Tag = area ? "textarea" : "input";
  return (
    <div className={`nx-fl${err ? " bad" : ""}`}>
      <Tag id={`f-${name}`} name={name} type={area ? undefined : type} rows={area ? 5 : undefined}
        placeholder=" " autoComplete={auto} onBlur={onBlur}
        aria-invalid={!!err} aria-describedby={err ? `e-${name}` : undefined} />
      <label htmlFor={`f-${name}`}>{label}</label>
      {err && <small id={`e-${name}`} className="nx-err" role="alert">{err}</small>}
    </div>
  );
}

function Method({ icon: Icon, title, value, link, c }) {
  const inner = (
    <>
      <span className="nx-m-ic"><Icon /></span>
      <span className="nx-m-tx"><b>{title}</b><small>{value}</small></span>
      {link && <FaArrowRight className="nx-m-ar" aria-hidden="true" />}
    </>
  );
  return (
    <li style={{ "--c": c }}>
      {link
        ? <a href={link} target={link.startsWith("http") ? "_blank" : undefined} rel="noreferrer">{inner}</a>
        : <div>{inner}</div>}
    </li>
  );
}

export default function Contact() {
  const [st, setSt] = useState("");
  const [errs, setErrs] = useState({});

  useEffect(() => { document.title = "Contact | Aayam Bhattarai"; }, []);

  const check = e => {
    const { name, value } = e.target;
    if (RULES[name]) setErrs(x => ({ ...x, [name]: RULES[name](value) }));
  };

  async function submit(e) {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    const next = {};
    Object.keys(RULES).forEach(k => { const m = RULES[k](String(data.get(k) || "")); if (m) next[k] = m; });
    setErrs(next);
    const bad = Object.keys(next)[0];
    if (bad) { form.elements[bad].focus(); return; }

    setSt("sending");
    try {
      const r = await fetch("https://formspree.io/f/mvgrreya", {
        method: "POST", body: data, headers: { Accept: "application/json" },
      });
      if (r.ok) { form.reset(); setSt("ok"); } else setSt("err");
    } catch { setSt("err"); }
  }

  return (
    <main className="nx-page nx-ctp">
      <header className="nx-ct-head">
        <p className="nx-ct-eye"><span>C</span> Contact</p>
        <h1>Let's build something <em>together</em></h1>
        <p className="nx-ct-sub">
          Have a project, a role or an idea in mind? Send a message and I'll get back to you.
        </p>
      </header>

      <div className="nx-ct">
        {st === "ok" ? (
          <div className="nx-card-box nx-done" role="status">
            <FaCheckCircle />
            <h2>Message sent</h2>
            <p>Thanks for reaching out. I'll get back to you as soon as I can.</p>
            <button className="nx-btn nx-btn-g" onClick={() => setSt("")}>Send another</button>
          </div>
        ) : (
          <form className="nx-card-box" onSubmit={submit} noValidate>
            <h2>Send a message</h2>
            <p className="nx-card-cap">Tell me a little about what you have in mind.</p>
            <Field name="name" label="Your name" auto="name" err={errs.name} onBlur={check} />
            <Field name="email" label="Email address" type="email" auto="email" err={errs.email} onBlur={check} />
            <Field name="subject" label="Subject (optional)" />
            <Field name="message" label="How can I help?" area err={errs.message} onBlur={check} />
            <button type="submit" className="nx-btn nx-btn-r" disabled={st === "sending"}>
              {st === "sending" ? "Sending…" : <>Send message <FaPaperPlane /></>}
            </button>
            {st === "err" && <p className="nx-bad" role="alert">Couldn't send. Please email me directly instead.</p>}
          </form>
        )}

        <div className="nx-card-box">
          <h2>Reach me directly</h2>
          <p className="nx-card-cap">Prefer a quicker chat? Pick whatever suits you.</p>

          <h3 className="nx-mg">Get in touch</h3>
          <ul className="nx-methods">
            {DIRECT.map(m => <Method key={m.title} {...m} />)}
          </ul>

          <h3 className="nx-mg">Find me online</h3>
          <ul className="nx-methods">
            {ONLINE.map(m => <Method key={m.title} {...m} />)}
            <Method {...LOCATION} />
          </ul>
        </div>
      </div>
    </main>
  );
}
